export const dummyCords = {
  lat: -20.165,
  lng: 28.597,
};

export const dummyPayloadData = {
  iso_cntry_id: "252",
  iso_city_id: "247850",
  svc_type_id: "231",
};
